module.exports = __webpack_public_path__ + "img/SarahSotelo.4bccaacb.jpg";